import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS, computed } from 'mobx';
import { observer } from 'mobx-react'

import Slider from 'react-rangeslider';
import {IconText,IconArrow, IconFontBold, IconFontUnderline, IconFontCenter, IconFontItalic, IconFontLeft, IconFontRight, IconFontSpace, IconFontSize, IconFill} from './Icons';

import Picker from './Picker';
import Select from 'react-select';
import Tip from './Tip';
import AutosizeInput from 'react-input-autosize';
import BaseText from './BaseText';
import Settings from './Settings';

@observer
export default class Text  extends BaseText  {

  render() {

    const t = this.t;
    const currentFontStyle = toJS(this.currentFontStyle);
    let fontSizes = [];
    for ( var i = 0; i < 100; i++ )
    {
      let obj = {
        label : i+'px',
        value : i*10,
      }
      fontSizes.push(obj);
    }


    return (
      <div className="bf-tools js-tools js-tools-open">

        <div className="hackForIOSMobile">smiel</div>
        <h6 className="tools-title js-tools-on-off"><IconText/>{t('text')}</h6>
        <span className="tools-on-off js-tools-on-off">
          <IconArrow/>
        </span>

        <div className={"Text " + ( !Settings.getSettingsIsActiveText ? " disable-area" : "" )}>
          {
            ( !Settings.getSettingsIsActiveText )
            &&
            <div className="UniversalPrevent"></div>
          }

          <div className="font-first">
            <Select
              className="Text-select"
              options={this.fonts}
              onChange={ (val) => { this.changeFontFamily(val) } }
              optionRenderer={this.fontRenderOption}
              valueRenderer={this.renderValue}
              value={Settings.getSettingsCurrentFont.family}
              clearable={false}
              searchable={false}

            />
          </div>

          <div className="Text-row">
            <div className="Text-fontSize">
              <span className="Text-icon">
                <IconFontSize/>
              </span>
              <div className="Text-select-v2">
                <div className="Text-select-v2-input" onClick={ ()=>{ this.showTipFontSize = true; this.textNameInput.focus()}}>
                  <AutosizeInput   ref={(input) => { this.textNameInput = input; }}  value={Settings.getSettingsCurrentFont.size}  onChange={(e)=>{ this.currentFontSizeInputChange(e)}} />
                  <span>px</span>
                  <IconArrow active={true}/>
                </div>
                {
                  this.showTipFontSize
                  &&
                  <Tip
                    handleClickOutside={ ()=> { this.showTipFontSize = false; }}
                    style={{width: '160px', padding: '12px 10px'}}>
                    <Slider
                      min={6}
                      max={60}
                      value={Settings.getSettingsCurrentFont.size}
                      onChange={ (val)=> { this.changeFontSize(val) } }
                      // onChangeComplete={ ()=> { this.changeFontSize() } }
                    />
                  </Tip>
                }


              </div>
              {
                false
                &&
                <Select
                  className="Text-select"
                  options={fontSizes}
                  value={Settings.getSettingsCurrentFont.size}
                  onChange={ (e) => {
                    this.changeFontSize(e)
                  } }
                  clearable={false}
                  searchable={false}
                />
              }

            </div>

            <div className="Text-fontSpace">
              <span className="Text-icon">
                  <IconFontSpace/>
              </span>

                <Select
                  className="Text-select"
                  options={fontSizes}
                  value={Settings.getSettingsCurrentFont.space}
                  onChange={ (e)=> {  this.changeFontSpace(e) } }
                  clearable={false}
                  searchable={false}
                />

            </div>

          </div>
          <div className="Text-row">
            <div className="Text-fontStyle">
              <div
                style={ {fontWeight : 'bold'} }
                onClick={ () => { this.setFontStyle('fontWeight') } }
                className={ ( Settings.getSettingsCurrentFont.style.fontWeight == 'bold' ) ? 'active ' : '' }
              ><IconFontBold/></div>
              <div
                style={ {fontStyle : 'italic'} }
                onClick={  () => { this.setFontStyle('fontStyle') } }
                className={ ( Settings.getSettingsCurrentFont.style.fontStyle == 'italic' ) ? 'active ' : '' }
              ><IconFontItalic/></div>
              <div
                style={ {textDecoration : 'underline'} }
                onClick={  () => { this.setFontStyle('textDecoration') } }
                className={ ( Settings.getSettingsCurrentFont.style.textDecoration == 'underline' ) ? 'active ' : '' }
              ><IconFontUnderline/></div>

            </div>
            <div className="Text-fontStyle">
              <div
                onClick={ () => { this.setFontStyle('textAlign','left') } }
                className={ ( Settings.getSettingsCurrentFont.style.textAlign == 'left' ) ? 'active ' : '' }
              >
                <IconFontLeft/>

              </div>
              <div
                onClick={ () => { this.setFontStyle('textAlign','center') } }
                className={ ( Settings.getSettingsCurrentFont.style.textAlign == 'center' ) ? 'active ' : '' }
              >
                <IconFontCenter/>

              </div>
              <div
                onClick={ () => { this.setFontStyle('textAlign','right') } }
                className={ (Settings.getSettingsCurrentFont.style.textAlign == 'right' ) ? 'active ' : '' }
              >
                <IconFontRight/>

              </div>

            </div>
            <span className="Text-color" onClick={ ()=> { this.showTextPicker = !this.showTextPicker; }}>
              <span className="Text-icon">
                <IconFill/>
              </span>
              <span className="Text-color-box" style={{backgroundColor: Settings.getSettingsCurrentFont.color}}></span>
            </span>

          </div>


        </div>

        {
          this.showTextPicker
          &&
          <Picker
            //currentColor={this.currentTextColor} // todo: add this option
            dictionaryStorage={this.props.dictionaryStorage}
            onChoiceColor={  (color)=> { this.onChoiceColor(color) } }
            onClickOutside={ ()=> { this.toggleTextColorPicker() } }
          >
          </Picker>
        }

      </div>
    );


  }
}


